import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/common/ProtectedRoute';

// Admin Pages
import AdminLogin from '../../pages/admin/AdminLogin';
import AdminDashboard from '../../pages/admin/AdminDashboard';
import AdminAppointments from '../../pages/admin/AdminAppointments';
import AdminSettings from '../../pages/admin/AdminSettings';
import AdminTestimonials from '../../pages/admin/AdminTestimonials';
import AdminMessages from '../../pages/admin/AdminMessages';
import AdminTreatments from '../../pages/admin/AdminTreatments';
import AdminServices from '../../pages/admin/AdminServices';
import AdminServiceCategories from '../../pages/admin/AdminServiceCategories';
import AdminDoctors from '../../pages/admin/AdminDoctors';
import AdminFAQs from '../../pages/admin/AdminFAQs';

const AdminRoutes = [
  <Route key="admin-login" path="/admin/login" element={<AdminLogin />} />,
  <Route 
    key="admin-dashboard"
    path="/admin/dashboard" 
    element={
      <ProtectedRoute>
        <AdminDashboard />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="admin-appointments"
    path="/admin/appointments" 
    element={
      <ProtectedRoute>
        <AdminAppointments />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="admin-testimonials"
    path="/admin/testimonials" 
    element={
      <ProtectedRoute>
        <AdminTestimonials />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="admin-messages"
    path="/admin/messages" 
    element={
      <ProtectedRoute>
        <AdminMessages />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="admin-treatments"
    path="/admin/treatments" 
    element={
      <ProtectedRoute>
        <AdminTreatments />
      </ProtectedRoute>
    } 
  />,
  <Route
    key="admin-faqs"
    path="/admin/faqs"
    element={
      <ProtectedRoute>
        <AdminFAQs />
      </ProtectedRoute>
    }
  />,
  <Route
    key="admin-settings"
    path="/admin/settings"
    element={
      <ProtectedRoute>
        <AdminSettings />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="admin-services"
    path="/admin/services" 
    element={
      <ProtectedRoute>
        <AdminServices />
      </ProtectedRoute>
    } 
  />,
  <Route
    key="admin-service-categories"
    path="/admin/service-categories"
    element={
      <ProtectedRoute>
        <AdminServiceCategories />
      </ProtectedRoute>
    }
  />,
  <Route
    key="admin-doctors"
    path="/admin/doctors"
    element={
      <ProtectedRoute>
        <AdminDoctors />
      </ProtectedRoute>
    } 
  />
];

export default AdminRoutes;
